import React from "react";
import './ImageTitle.css'
import Typography from "@mui/material/Typography";


interface ImageTitleProps {
    imageUrl: string;
    title: string;
    path: string
}

const ImageTitle: React.FC<ImageTitleProps> = ({ imageUrl, title, path }) => {
    return(
        <>
            <div className="image-overlay">
                <img src={imageUrl} alt="Background" className="background-image" />
                <div className="overlay">
                    <div style={{ fontSize: '45px' }}>
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                            }}
                        >
                            {title}
                        </Typography>
                    </div>
                    <div style={{ fontSize: '16px', height: '20px',  }}>
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 400,
                            }}
                        >
                            {path}
                        </Typography>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ImageTitle;